var _ = require("lodash");

var prune = require("underscore.string/prune");

var _require = require("./hast-processing"),
    getConcatenatedValue = _require.getConcatenatedValue,
    cloneTreeUntil = _require.cloneTreeUntil,
    findLastTextNode = _require.findLastTextNode; // stolen from gatsby/packages/gatsby-transformer-remark/src/extend-node-type.js


function excerptAst(node, _ref) {
  var _ref$pruneLength = _ref.pruneLength,
      pruneLength = _ref$pruneLength === void 0 ? 140 : _ref$pruneLength,
      _ref$truncate = _ref.truncate,
      truncate = _ref$truncate === void 0 ? false : _ref$truncate,
      excerptSeparator = _ref.excerptSeparator,
      _ref$omission = _ref.omission,
      omission = _ref$omission === void 0 ? "\u2026" : _ref$omission;

  if (!node.children.length) {
    return node;
  }

  if (excerptSeparator) {
    var _cloneTreeUntil = cloneTreeUntil(node, function (_ref2) {
      var nextNode = _ref2.nextNode;
      return nextNode.value === excerptSeparator;
    }),
        tree = _cloneTreeUntil.tree,
        is_pruned = _cloneTreeUntil.is_pruned;

    if (is_pruned) {
      return tree;
    }
  } else if (!pruneLength || pruneLength < 0) {
    return node;
  }

  var _cloneTreeUntil2 = cloneTreeUntil(node, function (_ref3) {
    var root = _ref3.root;
    var totalExcerptSoFar = getConcatenatedValue(root);
    return totalExcerptSoFar && totalExcerptSoFar.length > pruneLength;
  }),
      excerptAST = _cloneTreeUntil2.tree;

  var unprunedExcerpt = getConcatenatedValue(excerptAST);

  if (!unprunedExcerpt || pruneLength && unprunedExcerpt.length < pruneLength) {
    return excerptAST;
  }

  var lastTextNode = findLastTextNode(excerptAST);
  var amountToPruneBy = unprunedExcerpt.length - pruneLength;
  var desiredLengthOfLastNode = lastTextNode.value.length - amountToPruneBy;

  if (!truncate) {
    lastTextNode.value = prune(lastTextNode.value, desiredLengthOfLastNode, omission);
  } else {
    lastTextNode.value = _.truncate(lastTextNode.value, {
      length: pruneLength,
      omission: omission
    });
  }

  return excerptAST;
}

module.exports = excerptAst;